<div class="cosmos-cluster-add-collaborator__form">
  <div class="cosmos-cluster-add-collaborator__title-close-wrapper">
    <div class="cosmos-cluster-add-collaborator__title-close-wrapper__title">
      Add Collaborator
    </div>
    <div class="cosmos-cluster-add-collaborator__title-close-wrapper__button">
      <button
        (click)="closeModal()"
        class="cosmos-cluster-add-collaborator__title-close-wrapper__button"
      >
        <mat-icon>
          <span>close</span>
        </mat-icon>
      </button>
    </div>
  </div>
  <form
    [formGroup]="_collaboratorForm"
    (submit)="closeModal(this._collaboratorForm.value.userId)"
  >
    <input
      formControlName="userId"
      type="number"
      placeholder="User ID"
      class="cosmos-cluster-add-collaborator__form__input"
    >
    <div class="cosmos-cluster-add-collaborator__form__buttons">
      <button
        (click)="closeModal()"
        type="button"
        class="cosmos-cluster-add-collaborator__form__buttons__cancelButton"
      >
        Cancel
      </button>
      <button
        [disabled]="!_collaboratorForm.valid"
        type="submit"
        class="cosmos-cluster-add-collaborator__form__buttons__addButton"
      >
        Add
      </button>
    </div>
  </form>
</div>

